import axios from "axios";
import { API } from "../App";

export function track(event, detail = "", page = "") {
  try {
    axios.post(`${API}/track`, { event, detail, page });
  } catch {}
}
